export default {
    //apiUrl:'http://172.16.3.47:18691',
    //apiUrl:'http://jrisp.icwn.cn:800',
    //apiUrl: 'http://demo.starcapitalchina.com:83',
    apiUrl: 'https://isp.starcapitalchina.com',
    mobileHttp: 'http://www.starcapitalchina.com/Mobile/index.html'
}
